import {
  Button,
  Grid,
  MenuItem,
} from "@material-ui/core";
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import moment from "moment";
import "moment/locale/es";
import React from "react";
import { useSelector } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import { CATEGORIAS_VALORIZACIONES_ARRAY, TIPO_MATRICULA } from "../../../utils/constants";
import { SUBTIPO_EFECTORES } from "../../../utils/constants";

export const PrestadoresForm = (props) => {
  moment.locale("es");
  const { formData } = props
  const { dataContrato } = useSelector((state) => state.contrataciones);

  let nuevoPrestador = {
    idPrestador: null,
    nombreApellido: dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ? dataContrato.razonSocial : "",
    cuit: dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ? dataContrato.cuit : "",
    rnp: "",
    idCategoriaValorizaciones: "",
    prestadoresMatriculas: [],
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor
  ] = useForm(formData ? formData : nuevoPrestador);

  const {
    nombreApellido,
    cuit,
    rnp,
    idCategoriaValorizaciones,
    prestadoresMatriculas,
  } = formValues;

  const mostrarMatriculasRNP =
    dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_AJENOS ||
    dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ||
    dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL ||
    dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.INTEGRACION;

  const onChangeMatriculasHandler = (event) => {
    debugger
    const indiceMatriculaPrevia = prestadoresMatriculas.findIndex(
      (matricula) => parseInt(matricula.idTipoMatricula) === parseInt(event.target.name)
    );
    if (indiceMatriculaPrevia !== -1) {
      const matriculasActualizadas = [...prestadoresMatriculas];
      matriculasActualizadas[indiceMatriculaPrevia] = {
        ...matriculasActualizadas[indiceMatriculaPrevia],
        idTipoMatricula: parseInt(event.target.name),
        numero: event.target.value,
      };
      setearValor("prestadoresMatriculas", matriculasActualizadas);
    } else {
      const matriculasActualizadas = [
        ...prestadoresMatriculas,
        { idTipoMatricula: parseInt(event.target.name), numero: event.target.value },
      ];
      setearValor("prestadoresMatriculas", matriculasActualizadas);
    }
  };

  const handleSave = (e) => {
    e.preventDefault();

    const datosFormateados = {
      ...formValues,
      matriculas: prestadoresMatriculas,
    };
    delete datosFormateados.prestadoresMatriculas;

    props.handleSubmit(datosFormateados);
  };

  return (
    <ValidatorForm onSubmit={handleSave}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextValidator
            fullWidth
            margin="normal"
            label="Nombre y Apellido"
            name="nombreApellido"
            value={nombreApellido}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["El nombre es requerido"]}
          />
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            fullWidth
            margin="normal"
            label="CUIT"
            name="cuit"
            value={cuit || ""}
            onChange={handleInputChange}
            validators={[
              "required",
              "isNumber",
              "maxNumber:99999999999",
              "minNumber:9999999999",
            ]}
            errorMessages={[
              "El cuit es requerido",
              "solo numeros",
              "Verifique el cuil",
              "Verifique el cuil",
            ]}
          />
        </Grid>

        {mostrarMatriculasRNP && (
          <React.Fragment>
            <Grid item xs={5}>
              <TextValidator
                fullWidth
                margin="normal"
                label="Matricula Nacional"
                name={TIPO_MATRICULA.MATRICULA_NACIONAL}
                value={
                  prestadoresMatriculas?.find(
                    (matricula) =>
                      parseInt(matricula.idTipoMatricula) ===
                      TIPO_MATRICULA.MATRICULA_NACIONAL
                  )?.numero || ""
                }
                onChange={onChangeMatriculasHandler}
              ></TextValidator>
            </Grid>
            <Grid item xs={5}>
              <TextValidator
                fullWidth
                margin="normal"
                label="Matricula Provincial"
                name={TIPO_MATRICULA.MATRICULA_PROVINCIAL}
                value={
                  prestadoresMatriculas?.find(
                    (matricula) =>
                      parseInt(matricula.idTipoMatricula) ===
                      TIPO_MATRICULA.MATRICULA_PROVINCIAL
                  )?.numero || ""
                }
                onChange={onChangeMatriculasHandler}
              ></TextValidator>
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                label="RNP"
                name="rnp"
                value={rnp || ""}
                onChange={(e) => setearValor("rnp", e.target.value)}
              />
            </Grid>
          </React.Fragment>
        )}
      </Grid>
      {
        (dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS
          || dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES) &&

        <Grid item xs={6}>
          <SelectValidator
            fullWidth
            label="Categoria"
            name="idCategoriaValorizaciones"
            value={idCategoriaValorizaciones}
            onChange={handleInputChange}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {CATEGORIAS_VALORIZACIONES_ARRAY.map(e => <MenuItem key={e.id} value={e.id}>{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
      }
      <div style={{ textAlign: "right", marginTop: "2rem" }}>
        <Button type="submit" color="primary">
          Aceptar
        </Button>
        <Button onClick={props.handleCloseModal} type="button" color="primary">
          Cancelar
        </Button>
      </div>
    </ValidatorForm>
  );
};
